import React from 'react';

const RUN_STATUS_CLASS = {
    queued:    'bg-secondary',
    running:   'bg-warning text-dark',
    sent:      'bg-success',
    partial:   'bg-warning text-dark',
    failed:    'bg-danger',
    cancelled: 'bg-secondary',
};

function fmt(dt) {
    if (!dt) return '—';
    return new Date(dt).toLocaleString();
}

export default function SendRunHistory({ sendRuns }) {
    if (!sendRuns || sendRuns.length === 0) {
        return <p className="text-muted small">No send runs recorded yet.</p>;
    }
    return (
        <div className="table-responsive">
            <table className="table table-sm">
                <thead>
                    <tr>
                        <th>Status</th>
                        <th>Started</th>
                        <th>Finished</th>
                        <th>Total</th>
                        <th>Sent</th>
                        <th>Failed</th>
                        <th>Skipped</th>
                        <th>Batches</th>
                    </tr>
                </thead>
                <tbody>
                    {sendRuns.map((run) => (
                        <tr key={run.id}>
                            <td>
                                <span className={`badge ${RUN_STATUS_CLASS[run.status] || 'bg-secondary'}`}>
                                    {run.status_display}
                                </span>
                            </td>
                            <td className="small">{fmt(run.started_at)}</td>
                            <td className="small">{fmt(run.finished_at)}</td>
                            <td>{run.total_recipients}</td>
                            <td>{run.sent_count}</td>
                            <td className={run.failed_count > 0 ? 'text-danger fw-semibold' : ''}>
                                {run.failed_count}
                            </td>
                            <td>{run.skipped_count}</td>
                            <td>{run.batch_count}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
